import React from 'react';
import DogDisplayPage from './DogDisplayPage';
import { WidePhoto, TallPhoto, SquarePhoto } from './Constants';
import eevee1 from './assets/images/eevee/eevee1.jpg';
import eevee2 from './assets/images/eevee/eevee2.jpg';
import eevee3 from './assets/images/eevee/eevee3.jpg';
import eevee4 from './assets/images/eevee/eevee4.jpg';
import eevee5 from './assets/images/eevee/eevee5.jpg';
import eevee6 from './assets/images/eevee/eevee6.jpg';
import eevee7 from './assets/images/eevee/eevee7.jpg';
import eevee8 from './assets/images/eevee/eevee8.jpg';
import eevee9 from './assets/images/eevee/eevee9.jpg';
import eevee10 from './assets/images/eevee/eevee10.jpg';
import eevee11 from './assets/images/eevee/eevee11.jpg';
import eevee12 from './assets/images/eevee/eevee12.jpg';
import eevee13 from './assets/images/eevee/eevee13.jpg';
import eevee14 from './assets/images/eevee/eevee14.jpg';
import eevee15 from './assets/images/eevee/eevee15.jpg';
import eevee16 from './assets/images/eevee/eevee16.jpg';
import eevee17 from './assets/images/eevee/eevee17.jpg';
import eevee18 from './assets/images/eevee/eevee18.jpg';


const photos = [
    { src: eevee1, ...SquarePhoto },
    { src: eevee2, ...SquarePhoto },
    { src: eevee3, ...TallPhoto },
    { src: eevee4, ...WidePhoto },
    { src: eevee5, width: 100, height: 140 }, // non-standard size
    { src: eevee6, ...WidePhoto },
    { src: eevee7, width: 100, height: 150 }, // non-standard size
    { src: eevee8, ...WidePhoto },
    { src: eevee9, ...TallPhoto },
    { src: eevee10, ...TallPhoto },
    { src: eevee11, ...TallPhoto },
    { src: eevee12, ...TallPhoto },
    { src: eevee13, ...TallPhoto },
    { src: eevee14, ...TallPhoto },
    { src: eevee15, ...WidePhoto },
    { src: eevee16, ...TallPhoto },
    { src: eevee17, ...SquarePhoto },
    { src: eevee18, ...SquarePhoto },
];

const Eevee = () => {
    return (
        <DogDisplayPage photos={photos}>
            <h1 className="female">
                <i className="far fa-venus"></i>
                Eevee
            </h1>
            <table className="dog-chart">
                <tbody>
                    <tr>
                        <td><span className="title">Name</span>LUNANOVA SILVERSPRING WHO'S THAT POKEMON?</td>
                        <td><span className="title">Owner</span>CAROLYNNE ISSA / JOANNE SKALOS</td>
                        <td><span className="title">CKC Registration</span>#KW4223759</td>
                    </tr>
                    <tr>
                        <td><span className="title">Sire</span>CH DOMARCO N DREWSAR WE WILL ROCK YOU</td>
                        <td><span className="title">Dam</span>LUNANOVA'S DANCES WITH WOLVES AT SILVERSPRING</td>
                    </tr>
                    <tr>
                        <td><span className="title">Coat Type</span>Wavy</td>
                        <td><span className="title">Coat Colour</span>BLACK</td>
                    </tr>
                    <tr>
                        <td><span className="title">CAER</span>NORMAL</td>
                        <td><span className="title">CDDY/IVVD</span>NORMAL</td>
                        <td><span className="title">EOPRA</span>NORMAL</td>
                    </tr>
                    <tr>
                        <td><span className="title">GM-1</span>normal</td>
                        <td><span className="title">Improper Coat</span>normal</td>
                        <td><span className="title">JDCM</span>normal</td>
                        <td><span className="title">MICROPHTHALMIA SYNDROME</span>normal</td>
                    </tr>
                    <tr>
                        <td><span className="title">OFA Hips</span>FAIR (ELBOWS NORMAL)</td>
                        <td><span className="title">PRA</span>normal</td>
                    </tr>
                </tbody>
            </table>
        </DogDisplayPage>
    )
}
export default Eevee;
